import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import moment from 'moment';
import DayPicker from '../components/day-picker';

const MyDatePicker = createClass({
  propTypes: {
    onChange: PropTypes.func,
    value: PropTypes.shape({
      startDate: PropTypes.object,
      endDate: PropTypes.objec
    }).isRequired
  },

  onStartDate(date) {
    this.props.onChange({
      startDate: moment(date).startOf('day').toDate(),
      endDate: this.props.value.endDate
    });
  },
  onEndDate(date) {
    this.props.onChange({
      startDate: this.props.value.startDate,
      endDate: moment(date).endOf('day').toDate()
    });
  },

  render() {
    const {value = {}, defaultMonth} = this.props;
    const {startDate, endDate} = value;

    return (
      <div className='flex flex-align-top'>
        <div>
          <DayPicker
            value={startDate}
            toRange={endDate}
            defaultMonth={defaultMonth}
            onChange={this.onStartDate}
            disableDaysAfter={endDate}
          />
        </div>
        <div className='margin-left-2x'>
          <DayPicker
            value={endDate}
            toRange={startDate}
            defaultMonth={defaultMonth}
            onChange={this.onEndDate}
            disableDaysBefore={startDate}
          />
        </div>
      </div>

    );
  }
});

module.exports = MyDatePicker;
